import { useEffect, useRef } from "react";

import Ep57Img from "../../assets/images/conversations/ep-57-Vijay-Gokhale.webp";
import Ep56Img from "../../assets/images/conversations/ep-56-Ranjit-Kulkarni.webp";
import Ep54Img from "../../assets/images/conversations/ep-54-Pratik-Gupta.webp";
import Ep48Img from "../../assets/images/conversations/ep-48-Amara-Raja.webp";
import Ep47Img from "../../assets/images/conversations/ep-47-EMotorad.webp";
import Ep46Img from "../../assets/images/conversations/ep-46-Akshay-Singhal.webp";
import Ep45Img from "../../assets/images/conversations/ep-45-Sheetanshu-Tyagi.webp";
import Ep38Img from "../../assets/images/conversations/ep-38-Amara-Raja-Batteries.webp";

/* ─────────────────────────────────────────────
   PREFIX: bt-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .bt-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .bt-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .bt-page-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    padding-top: 60px;
    padding-bottom: 60px;
    letter-spacing: -0.5px;
  }

  .bt-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 30px;
    row-gap: 60px;
    padding-bottom: 100px;
  }

  .bt-card-wrap {
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .bt-card-wrap.bt-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .bt-card-wrap:nth-child(2) { transition-delay: 0.08s; }
  .bt-card-wrap:nth-child(3) { transition-delay: 0.16s; }
  .bt-card-wrap:nth-child(4) { transition-delay: 0.08s; }
  .bt-card-wrap:nth-child(5) { transition-delay: 0.16s; }
  .bt-card-wrap:nth-child(6) { transition-delay: 0.24s; }

  .bt-card {
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.35s ease;
    box-shadow: none;
  }
  .bt-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 48px rgba(116, 63, 172, 0.35);
  }
  .bt-card img {
    width: 100%;
    height: 300px;
    display: block;
    border-radius: 10px;
  }

  .bt-card__title {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 140%;
    margin-top: 20px;
  }
  .bt-card__read-more {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #743FAC;
    text-decoration: underline;
    transition: gap 0.25s ease, color 0.25s ease;
    margin-top: 16px;
  }
  .bt-card__read-more:hover {
    gap: 8px;
    color: #9B5FD4;
  }
  .bt-card__read-more svg {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .bt-inner { padding-left: 32px; padding-right: 32px; }
    .bt-page-title { font-size: 32px; padding-top: 32px; padding-bottom: 32px; }
    .bt-grid {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 20px;
      row-gap: 40px;
      padding-bottom: 48px;
    }
    .bt-card img { height: 220px; }
    .bt-card__title { margin-top: 18px; font-size: 15px; }
    .bt-card__read-more { margin-top: auto; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .bt-inner { padding-left: 16px; padding-right: 16px; }
    .bt-page-title { font-size: 30px; padding-top: 51px; padding-bottom: 30px; }
    .bt-grid {
      grid-template-columns: 1fr;
      column-gap: 0;
      row-gap: 40px;
    }
    .bt-card img { height: auto; }
    .bt-card__title { font-size: 14px; margin-top: 15px; }
    .bt-card__read-more { margin-top: 10px; }
  }
`;

function ArrowIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/* ─────────────────────────────────────────────
   BATTERY EPISODE DATA — sourced from energizingindia.tv/battery/
───────────────────────────────────────────── */
const EPISODES = [
  {
    img: Ep57Img,
    alt: "EP 57 Vijay Gokhale",
    title: "EP 57 | Navigating Geopolitics in a Shifting World Order | Vijay GOKHALE",
    href: "/ep57vijayfhokhalegeo/",
  },
  {
    img: Ep56Img,
    alt: "EP 56 Ranjit Kulkarni",
    title: "EP 56 | Fuels of the future with Honeywell | Ranjit KULKARNI",
    href: "/ep56honeywellranjitkulkarni/",
  },
  {
    img: Ep54Img,
    alt: "EP 54 Pratik Gupta",
    title: "EP 54 | Decoding the Future of Urban Electric Mobility | Gensol EV | Pratik Gupta",
    href: "/ep-54-decoding-the-future-of-urban-electric-mobility-gensol-ev-pratik-gupta/",
  },
  {
    img: Ep48Img,
    alt: "EP 48 Amara Raja",
    title: "EP 48 | What is the future of lead acid batteries? | Amara Raja Energy & Mobility",
    href: "/ep-48-what-is-the-future-of-lead-acid-batteries-amara-raja-energy-mobility/",
  },
  {
    img: Ep47Img,
    alt: "EP 47 EMotorad",
    title: "EP 47 | Can electric cycles become a part of our everyday lives? | EMotorad",
    href: "/ep-47-can-electric-cycles-become-a-part-of-our-everyday-lives-emotorad/",
  },
  {
    img: Ep46Img,
    alt: "EP 46 Akshay Singhal",
    title: "EP 46 | Breaking down batteries with Log9 | Akshay Singhal",
    href: "/ep-46-breaking-down-batteries-with-log9-akshay-singhal/",
  },
  {
    img: Ep45Img,
    alt: "EP 45 Sheetanshu Tyagi",
    title: "EP 45 | Rediscovering the basics of batteries with Emo Energy | Sheetanshu Tyagi",
    href: "/ep-45-rediscovering-the-basics-of-batteries-with-emo-energy-sheetanshu-tyagi/",
  },
  {
    img: Ep38Img,
    alt: "EP 38 Amara Raja Batteries",
    title: "EP 38 | Taking the bull by the horns, legacy takes the future head on | Amara Raja Batteries",
    href: "/ep-38-taking-the-bull-by-the-horns-legacy-takes-the-future-head-on-amara-raja-batteries/",
  },
];

/* ─────────────────────────────────────────────
   CARD
───────────────────────────────────────────── */
function EpisodeCard({ img, alt, title, href }) {
  return (
    <div className="bt-card-wrap">
      <a href={href} className="bt-card" rel="noreferrer">
        <img src={img} alt={alt} />
      </a>
      <p className="bt-card__title">{title}</p>
      <a href={href} className="bt-card__read-more" rel="noreferrer">
        Read More <ArrowIcon />
      </a>
    </div>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function BatteryEpisodes() {
  const gridRef = useRef(null);

  useEffect(() => {
    const cards = gridRef.current?.querySelectorAll(".bt-card-wrap") || [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("bt-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>{CSS}</style>
      <div className="bt-page">
        <div className="bt-inner">
          <h1 className="bt-page-title">Battery Episodes</h1>
          <div className="bt-grid" ref={gridRef}>
            {EPISODES.map((ep, i) => (
              <EpisodeCard key={i} {...ep} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}